import { render, staticRenderFns } from "./origin-data-choice.vue?vue&type=template&id=79e89486&scoped=true"
import script from "./origin-data-choice.vue?vue&type=script&lang=js"
export * from "./origin-data-choice.vue?vue&type=script&lang=js"
import style0 from "./origin-data-choice.vue?vue&type=style&index=0&id=79e89486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e89486",
  null
  
)

export default component.exports